module.exports = __webpack_public_path__ + "img/bz4.a2a0e950.jpg";